import { Injectable } from '@angular/core';
import {Region} from '../interfaces/Region';
import {ActivatedRouteSnapshot} from '@angular/router';
import {RegionService} from '../services/region/region.service';
import {BreadCrumbAndDataHelperService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-helper.service';
import {BreadCrumbAndDataResolverService} from '../../utilities/services/route-resolvers/bread-crumb-and-data-resolver.service';

@Injectable()
export class RegionResolverService extends BreadCrumbAndDataResolverService<Region> {

    constructor(private regionService: RegionService, helper: BreadCrumbAndDataHelperService) {
        super(helper);
    }

    public async getData(route: ActivatedRouteSnapshot): Promise<Region> {
        return await this.regionService.getRegion(Number(route.params.regionId));
    }

    public getName(data: Region): string {
        return data.name;
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/region/resolvers/region-resolver.service.ts